import type { ScreenType } from '../types';

import { useStore } from 'vuex';

import { MODULE_NAME } from '../constants/moduleConstants';
import { MutationTypes } from '../store/mutations';

const useLoadingAction = () => {
  const store = useStore();

  const groupLoading = computed<boolean>(() => store?.state?.gemMeter.groupLoading);
  function changeGroupLoading(isLoading: boolean) {
    store.commit(`${MODULE_NAME}/${MutationTypes.CHANGE_GROUP_LOADING}`, isLoading);
  }

  const previousScreen = computed<ScreenType>(() => store?.state?.gemMeter.previousScreen);
  function changePreviousScreen(screenType: ScreenType) {
    store.commit(`${MODULE_NAME}/${MutationTypes.CHANGE_PREVIOUS_SCREEN}`, screenType);
  }

  return {
    groupLoading,
    changeGroupLoading,
    previousScreen,
    changePreviousScreen,
  };
};

export default useLoadingAction;
